var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#196DD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 67.5C26.25 67.5 22.5 67.5 22.5 63.75C22.5 60 26.25 48.75 45 48.75C63.75 48.75 67.5 60 67.5 63.75C67.5 67.5 63.75 67.5 63.75 67.5H26.25ZM45 45C47.9837 45 50.8452 43.8147 52.955 41.705C55.0647 39.5952 56.25 36.7337 56.25 33.75C56.25 30.7663 55.0647 27.9048 52.955 25.795C50.8452 23.6853 47.9837 22.5 45 22.5C42.0163 22.5 39.1548 23.6853 37.045 25.795C34.9353 27.9048 33.75 30.7663 33.75 33.75C33.75 36.7337 34.9353 39.5952 37.045 41.705C39.1548 43.8147 42.0163 45 45 45Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.19110c08af17b1565307731737058f18.svg";
export { ForwardRef as ReactComponent };